import { combineReducers } from 'redux'
import {
  createReducer,
  createRequestReducer
} from 'pobble-components/dist/redux-helpers'

const UserDetails = combineReducers({
  fetchUserRequest: createRequestReducer('USER:FETCH', {
    pending: true
  }),
  uploadAvatarRequest: createRequestReducer('USER:UPLOAD_AVATAR'),
  removeAvatarRequest: createRequestReducer('USER:REMOVE_AVATAR'),
  updateAccountRequest: createRequestReducer('USER:UPDATE'),
  user: createReducer(null, {
    'USER:FETCH_REQUEST_SUCCESS': (state, { response }) =>
      response.data.account,
    'USER:UPDATE_REQUEST_SUCCESS': (state, { response }) => ({
      ...state,
      ...response.data.account
    }),
    'USER:NEWSLETTER_REQUEST_SUCCESS': (state, { params, response }) => {
      return {
        ...state,
        newsletter: params.data.newsletter
      }
    },
    'USER:UPLOAD_AVATAR_REQUEST_SUCCESS': (state, { response }) => ({
      ...state,
      avatar: response.data.account.avatar
    }),
    'USER:REMOVE_AVATAR_REQUEST_SUCCESS': state => ({
      ...state,
      avatar: null
    }),
    'USER:UPDATE_STUDENT_AVATAR_SUCCESS': (state, { response }) => ({
      ...state,
      avatar: response.data.account.avatar
    }),
    'USER:LEAVE_REQUEST_SUCCESS': state => ({
      ...state,
      teacher_type: null
    }),
    'USER:CANCEL_PENDING_TEACHER_REQUEST_SUCCESS': state => ({
      ...state,
      pending_teacher_type: null
    })
  })
})

export default UserDetails
